const isActionColumn = (column) =>
  typeof column?.name === "string" && column.name.trim().toLowerCase() === "action";

export const normalizeActionColumns = (columns = []) =>
  columns.map((column) => {
    if (!isActionColumn(column)) return column;

    return {
      ...column,
      right: column.right ?? true,
      button: column.button ?? true,
      compact: column.compact ?? true,
      grow: column.grow ?? 0,
      width: column.width,
      minWidth: column.minWidth,
      style: {
        ...(column.style || {}),
        justifyContent: "flex-end",
        paddingLeft: 0,
        paddingRight: 0,
      },
    };
  });
